import BaseApi from "../../../services/Api";
import Swal from "sweetalert2";
import React, {useEffect, useState} from "react";
import Tooltip from "../../Popups/Tooltip";
import {Modal, Spinner} from "react-bootstrap";
import { intervalToDuration, formatDuration } from "date-fns";
import ptBR from 'date-fns/locale/pt-BR';


const ModalAnimalInfo = ({
  idAnimal, children
}) => {
  const [isLoading, setLoading] = React.useState(true);
  const [isShow, setShowModal] = React.useState(false);

  const [isPinned, setIsPinned] = useState(false);
  const [name, setName] = useState('');
  const [species, setSpecies] = useState('');
  const [description, setDescription] = useState('');
  const [wasAdopted, setWasAdopted] = useState(false);
  const [familyImage, setFamilyImage] = useState(null);
  const [animal_img, setAnimalImage] = useState(null);
  const [sex, setSex] = useState('');
  const [isCastrated, setIsCastrated] = useState(false);
  const [breed, setBreed] = useState('');
  const [birthday, setBirthday] = useState(null);
  const [size, setSize] = useState(''); 
  const [special_animal, setSpecialAnimal] = useState(false);

  const handleClose = () => {
    setShowModal(false);
  }

  const requestData = () => {
    setLoading(true);
    BaseApi.get(`/animais${idAnimal ? `/${idAnimal}` : ''}`).then(res => {
      let data = res.data;
      setIsPinned(data.is_pinned);
      setName(data.name)
      setSpecies(data.species);
      setDescription(data.description);
      setWasAdopted(data.was_adopted);
      setFamilyImage(data.family_image);
      setAnimalImage(data.animal_img);
      setSex(data.sex);
      setIsCastrated(data.is_castrated);
      setBreed(data.breed);
      setBirthday(data.birthday);
      setSize(data.size);
      setSpecialAnimal(data.special_animal);
      setLoading(false);
    }).catch(err => {
      console.log(err);
      Swal.fire('Oops!', err?.data?.errors?.[0] || err?.data?.message || 'Ocorreu um erro ao carregar este lead ou não foi encontrado.', 'error');
      setShowModal(false);
    })
  }

  useEffect(() => {
    if(isShow) {
      requestData();
    } else {
        setIsPinned(false);
        setName('')
        setSpecies('');
        setDescription('');
        setWasAdopted(false);
        setFamilyImage(null);
        setAnimalImage(null);
        setSex('');
        setIsCastrated(false);
        setBreed('');
        setBirthday('');
        setSize('');
        setSpecialAnimal(false);
        setLoading(true);
    }
  }, [isShow])

  const handleDate = (birthday) => {
      const todayDate = new Date();
      const birthdayDate = new Date(birthday);
  
      let duration = intervalToDuration({
        start: birthdayDate, 
        end: todayDate,
      })
      
      return formatDuration(duration, {
        format: ['years', 'months', 'weeks', 'days'],
          delimiter: ', ', 
          locale: ptBR
      })
  }

  return (
    <>
      {children &&
        React.cloneElement(children, { onClick: (e) => setShowModal(true) })}
      {!children && (
        <Tooltip text={"Informações do Animal"}>
          <button
            className={`btn btn-${idAnimal ? "warning" : ""} text-white fa-bold`}
            onClick={(e) => setShowModal(true)}
          >
            <i className={`bi bi-${idAnimal ? "person-gear" : "plus"}`}></i>
          </button>
        </Tooltip>
      )}
      <Modal
        centered
        scrollable
        onHide={handleClose}
        show={isShow}
        animation={true}
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>Informações do Animal</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center justify-content-center">
            {isLoading && (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            )}
          </div>
          {!isLoading && (
            <>
              <div className="row">
                  <div className="form-group mb-3">
                    <label htmlFor="is_pinned">Está fixado? </label> 
                    <select value={isPinned} name="isPinned" id="isPinned" className="form-select">
                        <option value="" disabled='disabled' selected>Selecione se está fixado ou não</option>
                        <option value={1}>Sim</option>
                        <option value={0}>Não</option>
                    </select>
                  </div>
                <div className="form-group mb-3">
                  <label htmlFor="name">Nome </label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    placeholder="nome"
                    value={name}
                  />
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="species">Espécie </label>
                  <select value={species} name="species" id="species" className="form-select">
                      <option value="" disabled='disabled' selected>Escolha a espécie do animal</option>
                      <option value="dog">Cachorro</option>
                      <option value="cat">Gato</option>
                  </select>
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="description">Descrição </label>
                  <textarea
                    type="text"
                    className="form-control"
                    id="description"
                    placeholder="Descrição do Animal"
                    value={description}
                  />
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="was_adopted">Foi adotado? </label> 
                  <select value={wasAdopted} name="wasAdopted" id="wasAdopted" className="form-select">
                      <option value="" disabled='disabled' selected>Selecione se o animal foi adotado ou não</option>
                      <option value={1}>Sim</option>
                      <option value={0}>Não</option>
                  </select>
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="sex">Gênero </label>
                  <select value={sex} name="sex" id="sex" className="form-select">
                      <option value="" disabled='disabled' selected>Escolha a espécie do animal</option>
                      <option value="male">Macho</option>
                      <option value="female">Fêmea</option>
                  </select>
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="is_castrated">É castrado? </label> 
                  <select value={isCastrated} name="isCastrated" id="isCastrated" className="form-select">
                      <option value="" disabled='disabled' selected>Selecione se o animal é castrado ou não</option>
                      <option value={1}>Sim</option>
                      <option value={0}>Não</option>
                  </select>
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="special_animal">É especial? </label> 
                  <select value={special_animal} name="special_animal" id="special_animal" className="form-select">
                      <option value="" disabled='disabled' selected>Selecione se o animal é especial ou não</option>
                      <option value={1}>Sim</option>
                      <option value={0}>Não</option>
                  </select>
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="breed">Raça </label>
                  <input
                    type="text"
                    className="form-control"
                    id="breed"
                    placeholder="raça"
                    value={breed}
                  />
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="birthday">Aniversário/Data aproximada </label>
                  <input
                    type="date"
                    className="form-control"
                    id="birthday"
                    value={birthday}
                  />
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="age">Idade </label>
                  <input
                    type="text"
                    className="form-control"
                    id="age"
                    value={handleDate(birthday)}
                  />
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="size">Tamanho </label>
                  <select value={size} name="size" id="size" className="form-select">
                      <option value="" disabled='disabled' selected>Escolha o tamanho do animal</option>
                      <option value="small">Pequeno</option>
                      <option value="medium">Médio</option>
                      <option value="large">Grande</option>
                      <option value="undefined">Indefinido</option>
                  </select>
                </div>
                {wasAdopted ? 
                  <div className="form-group mb-3">
                    <label htmlFor="family_image">Imagem com a família </label>
                    
                    {idAnimal ? (
                      <div className="d-flex justify-content-center align-items-center mt-2">
                        <img
                          src={familyImage instanceof File ? URL.createObjectURL(familyImage) : familyImage}
                          alt="imagem da família"
                          style={{ minWidth: 250, width: 350, objectFit: 'cover' }}
                        />
                      </div>
                    ) : 
                      null
                    }

                    {familyImage && !idAnimal && (
                      <div className="d-flex justify-content-center align-items-center mt-2">
                        {idAnimal ? <img src={familyImage} alt="imagem" style={{minWidth: 250, width: 350, objectFit: "cover"}}/>
                          : <img src={URL.createObjectURL(familyImage)} alt="imagem" style={{minWidth: 250, width: 350, objectFit: "cover"}}/>
                        }
                        </div>
                      )
                    }
                  </div>
                  : null
                }
                <div className="form-group mb-3">
                  <label htmlFor="animal_img">Imagem do Animal </label>

                
                  
                  {idAnimal ? (
                    <div className="d-flex justify-content-center align-items-center mt-2">
                      <img
                        src={animal_img instanceof File ? URL.createObjectURL(animal_img) : animal_img}
                        alt="animal_img"
                        style={{ minWidth: 250, width: 350, objectFit: 'cover' }}
                      />
                    </div>
                  ) : 
                    null
                  }

                  {animal_img && !idAnimal && (
                    <div className="d-flex justify-content-center align-items-center mt-2">
                      {idAnimal ? <img src={animal_img} alt="animal_img" style={{minWidth: 250, width: 350, objectFit: "cover"}}/>
                        : <img src={URL.createObjectURL(animal_img)} alt="animal_img" style={{minWidth: 250, width: 350, objectFit: "cover"}}/>
                      }
                      </div>
                    )
                  }
                </div>

              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex align-items-center w-100">
            <div className="d-block me-auto"></div>
            <div className="d-block ms-auto">
              <button
                className="btn btn-danger text-white me-2"
                onClick={handleClose}
              >
                Close
              </button>
             
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalAnimalInfo;